import { useEffect } from 'react';
import type { ToastItem } from "@Components/Common/Toasts/toasts.slice";

export const useToast = (toast: ToastItem, onClose: (id: string) => void) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose(toast.id);
    }, toast.duration);

    return () => clearTimeout(timer);
  }, [toast, onClose]);
};
